import { useHistory } from 'react-router-dom'
import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    const history = useHistory()
    const items = [
        {
            text: "Parâmetros Técnicos",
            url: "/rinsContraste/parametrosTecnicos"
        },
        {
            text: "Posição do Paciente",
            url: "/rinsContraste/posicaoPaciente"
        },
        {
            text: "Programação",
            url: "/rinsContraste/linhasReferencia"
        },
        {
            text: "Reformatações Multiplanares",
            url: "/rinsContraste/reformatacoesMultiplanares"
        },
        {
            text: "Protocolos de Pós-processamento",
            url: "/rinsContraste/reformatacoes"
        },
        {
            text: "Back-up",
            url: "/rinsContraste/reformatacoes/backup"
        },
        {
            text: "Documentação",
            url: "/rinsContraste/reformatacoes/documentacao"
        }
    ]
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Tomografia Computadorizada Multislice Rins e vias urinarias
Urotomografia com Contraste I.V. </Title>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-10">
                    {
                        items.map(item => (
                            <button
                                key={item.url}
                                className="btn btn-info btn-block my-4"
                                onClick={
                                    () => history.push(`/tronco${ item.url }`)
                                }
                            >{ item.text }</button>
                        ))
                    }
                </div>
            </div>
        </Container>
    )
}